
import img1 from '../images/layouts/project1.png'
import img2 from '../images/layouts/project2.png'
import img3 from '../images/layouts/project3.png'
import img4 from '../images/layouts/project4.png'
import img5 from '../images/layouts/project5.png'
import img6 from '../images/layouts/project6.png'
import img7 from '../images/layouts/project7.png'
import img8 from '../images/layouts/project8.png'
import img9 from '../images/layouts/project9.png'

const dataProject = [

    {
        id: 1,
        img: img1,
        title: '3D Digital Artwork'
    },
    {
        id: 2,
        img: img2,
        title: 'King Of Pirates'
    },
    {
        id: 3,
        img: img3,
        title: 'Pomeranian Doge'
    },
    {
        id: 4,
        img: img7,
        title: 'Nintendo Switch'
    },
    {
        id: 5,
        img: img5,
        title: 'The Strange Art'
    },
    {
        id: 6,
        img: img6,
        title: '3D Digital Artwork'
    },
    {
        id: 7,
        img: img4,
        title: 'King Of Pirates'
    },
    {
        id: 8,
        img: img8,
        title: 'Pomeranian Doge'
    },
    {
        id: 9,
        img: img9,
        title: 'Nintendo Switch'
    },


    

]

export default dataProject;